import api from "./../api"; 
import { useCallback } from "react";

export const useIngresoINMOB = () => {

  const getingresos = async () => {
    try {
      const { data } = await api.get("/inmobiliaria/inmobiliaria/all/ingresos");
      return data;
    } catch (error) {
      console.error("Error al traer ingresos:", error);
      throw error.response?.data?.message || "Error al cargar ingresos";
    }
  };

   const crearingreso = async (nuevoingreso) => {
    try {
      const { data } = await api.post(`/inmobiliaria/inmobiliaria/crear/ingresos`, nuevoingreso,  {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
      return data;
    } catch (error) {
      console.error("💥 Error al crear ingreso:", error);
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };
const editaringreso = async (id, formData) => {
  try {
    const { data } = await api.post(
      `/inmobiliaria/inmobiliaria/editar/ingresos/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  } catch (error) {
    console.error("💥 Error al editar ingreso:", error);
    throw error.response?.data || error;
  }
};

 const eliminaringreso = async (id) => {
    try {
      const { data } = await api.delete(`/inmobiliaria/inmobiliaria/eliminar/ingresos/${id}`);
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar ingreso:", error);
      throw error.response?.data?.message || "Error al eliminar ingreso";
    }
  };

   const getCategoriaingresos = async () => {
    try {
      const { data } = await api.get("/inmobiliaria/categoria/all/ingresos");
      return data;
    } catch (error) {
      console.error("Error al traer ingresos:", error);
      throw error.response?.data?.message || "Error al cargar ingresos";
    }
  };
   const crearCategoriaingresos = async (nuevoCategoriaingreso) => {
    try {
      const { data } = await api.post(`/inmobiliaria/categoria/crear/ingresosinmob`, nuevoCategoriaingreso);
      return data;
    } catch (error) {
      console.error("💥 Error al crear ingreso:", error);
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };

  const editarCategoriaingresos = async (id, formData) => {
  try {
    const { data } = await api.post(
      `/inmobiliaria/categoria/editar/ingresos/${id}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("💥 Error al editar ingreso:", error);
    throw error.response?.data || error;
  }
};

 const eliminarCategoriaingresos = async (id) => {
    try {
      const { data } = await api.delete(`/inmobiliaria/categoria/eliminar/ingresos/${id}`);
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar ingreso:", error);
      throw error.response?.data?.message || "Error al eliminar ingreso";
    }
  };

   const getContactoInmobiliaria = useCallback(async () => {
  const { data } = await api.get("/inmobiliaria/contacto/all/egresos");
  return data;
}, []);

  const crearContactoInmobiliaria = async (payload) => {
    const { data } = await api.post(
      "/inmobiliaria/contacto/crear/egresos",
      payload
    );
    return data;
  };

  const editarContactoInmobiliaria = async (id, payload) => {
    const { data } = await api.put(
      `/inmobiliaria/contacto/editar/egresos/${id}`,
      payload
    );
    return data;
  };

  const eliminarContactoInmobiliaria = async (id) => {
    const { data } = await api.delete(
      `/inmobiliaria/contacto/eliminar/egresos/${id}`
    );
    return data;
};
    const getexcel = useCallback(async (mes, anio) => {
  try {
    const response = await api.get(
      "/inmobiliaria/ingresos-inmobiliaria/export",
      {
        params: { mes, anio }, 
        responseType: "blob", 
      }
    );

    return response;
  } catch (error) {
    console.error("Error al descargar excel:", error);
    throw error;
  }
}, []);

 const getfiltromeses = useCallback(async () => {
  const { data } = await api.get("/inmobiliaria/ingresos-inmobiliaria/meses");
  return data;
}, []);
  
const getfiltromesesyaño = useCallback(async (mes, anio) => {
  const { data } = await api.get(
    "/inmobiliaria/ingresos-inmobiliaria/filtro",
    {
      params: { mes, anio }
    }
  );
  return data;
}, []);

const descargarPdfingreso = async (expenseId) => {
  try {
    const response = await api.get(
      `/inmobiliaria/ingresoinmobiliaria/${expenseId}/descargar-pdf`,
      {
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "documento.pdf");

    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error al descargar PDF:", error);
  }
};
  return {
    getingresos,
    crearingreso,
    editaringreso,
    eliminaringreso,
    getCategoriaingresos,
    crearCategoriaingresos,
    editarCategoriaingresos,
    eliminarCategoriaingresos,
     /* contacto */
    getContactoInmobiliaria,
    crearContactoInmobiliaria,
    editarContactoInmobiliaria,
    eliminarContactoInmobiliaria,

    /* get */
    getexcel,
    getfiltromeses,
    getfiltromesesyaño,
    descargarPdfingreso
  };
}
